import React, { FC } from 'react';
import Chip from '~components/atoms/Chip';

import Modal from '~components/atoms/Modal';
import * as Styles from './_viewSerialNoModal.module.scss';

type ViewSerialNoModalModalProps = {
    isOpen: boolean;
    onClose: () => void;
    serialNo: string[];
}

const ViewSerialNoModalModal: FC<ViewSerialNoModalModalProps> = ({
    isOpen,
    onClose,
    serialNo,
}) => {

    const renderSerialNoList = () => {
        if (serialNo.length === 0) return 'There is no serial no. in the list';
        return serialNo.map((label) => <Chip key={label} label={label} type='info' testId='serial-number-chip' />);
    };
    return (
        <Modal
            testId='view-serial-number-modal-close'
            isOpen={isOpen}
            onClose={onClose}
            title='Serial No. List'
        >
            <div className={Styles.container}>
                {renderSerialNoList()}
            </div>
        </Modal>
    );
};

export default ViewSerialNoModalModal;
